import axios from 'axios';
import { ErrorHandler } from '../defaultApiErrorHandler';
import {
    FormNotFoundError,
    INVALID_ENCRYPTED_ID_ERROR_TYPE,
    InvalidFormLinkError,
    RESTRICTED_FORM_NO_ACCESS_ERROR_TYPE,
    RestrictedFormAccessError,
    SIMPLE_FORM_ARCHIVED_ERROR_TYPE,
    SimpleFormArchivedError,
} from '../simpleForm/errorHandler';

export class ProjectsValidationError extends Error {
    constructor(message: string = 'Projects validation error') {
        super(message);
        this.name = 'ProjectsValidationError';
        // errorEvents.emit('error_occured');
    }
}

export class ProjectsErrorHandler implements ErrorHandler {
    handleError(error: unknown): never {
        if (axios.isAxiosError(error)) {
            const status = error.response?.status;
            const message = error.response?.data?.error?.message;
            const errorType = error.response?.data?.error?.errorType;

            if (
                status === 403 &&
                errorType === RESTRICTED_FORM_NO_ACCESS_ERROR_TYPE
            ) {
                throw new RestrictedFormAccessError(message);
            }

            if (
                status === 410 &&
                errorType === SIMPLE_FORM_ARCHIVED_ERROR_TYPE
            ) {
                throw new SimpleFormArchivedError(message);
            }

            if (
                status === 422 &&
                errorType === INVALID_ENCRYPTED_ID_ERROR_TYPE
            ) {
                localStorage.removeItem('encryptedSimpleProjectsId');
                throw new InvalidFormLinkError(message);
            }

            if (status === 404) {
                localStorage.removeItem('encryptedSimpleProjectsId');
                throw new FormNotFoundError(message);
            }

            if (status === 422) {
                localStorage.removeItem('encryptedSimpleProjectsId');
                throw new ProjectsValidationError(message);
            }
        }
        throw error;
    }
}
